import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {APIResponse} from '@core/interfaces/system/system-common';
import {N1AnalysisApi} from '@core/backend/engin/api/load-forecast/n1-analysis.api';
import {
    FeederAnalysisImpact,
    FeederList,
    N1AnalysisDetailsRequest,
    N1AnalysisService,
    TransformerAnalysis,
    TransformerDetailedList,
    TransformerImpactSummary,
    TransformerList,
} from '@core/interfaces/engin/load-forecast/n1-analysis';

@Injectable()
export class N1AnalysisServiceImpl extends N1AnalysisService {
    constructor(private api: N1AnalysisApi) {
        super();
    }

    public getFeedersLoadData(
        workflowItemId: number,
        params: N1AnalysisDetailsRequest,
    ): Observable<APIResponse<FeederList>> {
        return this.api.getFeedersLoadData(workflowItemId, params);
    }

    public getTransformersLoadData(
        workflowItemId: number,
        params: N1AnalysisDetailsRequest,
    ): Observable<APIResponse<TransformerList>> {
        return this.api.getTransformersLoadData(workflowItemId, params);
    }

    public getTransformerFeederTieResults(
        workflowItemId: number,
        params: N1AnalysisDetailsRequest,
    ): Observable<APIResponse<TransformerAnalysis>> {
        return this.api.getTransformerFeederTieResults(workflowItemId, params);
    }

    public getFeederTieResults(
        workflowItemId: number,
        params: N1AnalysisDetailsRequest,
    ): Observable<APIResponse<FeederAnalysisImpact>> {
        return this.api.getFeederTieResults(workflowItemId, params);
    }

    public getTransformerImpact(
        workflowItemId: number,
        params: N1AnalysisDetailsRequest,
    ): Observable<APIResponse<TransformerDetailedList>> {
        return this.api.getTransformerImpact(workflowItemId, params);
    }

    public getTransformerImpactSummary(
        workflowItemId: number,
        params: N1AnalysisDetailsRequest,
    ): Observable<APIResponse<TransformerImpactSummary>> {
        return this.api.getTransformerImpactSummary(workflowItemId, params);
    }
}
